import { createStateHook } from 'react-sweet-state';

import { EMPTY_SELECTED_AGENT_IDS } from './emptySelectedAgentIds';
import {
	selectedAgentDraftControllerStore,
	type SelectedAgentDraftControllerStore,
} from './selectedAgentDraftControllerStore';

const useConversationDeactivatedSelectedAgentIds = createStateHook(
	selectedAgentDraftControllerStore,
	{
		selector: (
			state: SelectedAgentDraftControllerStore,
			conversationId: string,
		): readonly string[] => state.deactivatedAgentIds[conversationId] ?? EMPTY_SELECTED_AGENT_IDS,
	},
);

export const useDeactivatedSelectedAgentIds = (conversationId: string): readonly string[] =>
	useConversationDeactivatedSelectedAgentIds(conversationId);
